var addressDirective = {
   restrict: 'E',
   templateUrl: require('./view.html'),
   scope: {
      'address': '=',
      'address2': '=',
      'city': '=',
      'state': '=',
      'country': '=',
      'zip': '='
   }
};

angular.module('e360')
   .directive('address', function() { return addressDirective; });
